// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament_match_filter_item, .tournament_match_filter_item__checkbox-list {
    max-height: 300px;
    padding: 16px 20px;
}

.tournament_match_filter_item .MuiToggleButtonGroup-root{
    display: flex;
    /* grid-template-columns: 35% 35% 35%; */
    border-radius: 4px;
    flex-wrap: wrap;
    justify-content: flex-start;
}

.tournament_match_filter_item_checkbox{
    display: flex;
    justify-content: space-between;
    margin-bottom: var(--space-half-quarter);
}

.tournament_filter{
    margin: var(--space) 0;
}

.tournament_match_filter_item_checkbox_label.baloa-table {
    color: var(--primary-very-dark-color);
}

.tournament_match_filter_item_checkbox_label#Scheduled{
    background-color: #3078B3;
    padding: var(--space-quarter);
    color: var(--white-color);
}
.tournament_match_filter_item_checkbox_label#Finalized{
    background-color: var(--basic-gray-color);
    padding: var(--space-quarter);
    color: var(--white-color);
}
.tournament_match_filter_item_checkbox_label#Not_scheduled{
    background-color: var(--new-yellow-color);
    padding: var(--space-quarter);
    color: var(--white-color);
}

.tournament_item_ubication_city.baloa-username{
    color: var(--white-color);
    font-weight: var(--font-medium);
}

.tournament_item_ubication_city .icon-x{
    color: var(--white-color);
}

.tournament_item_ubication_city .icon-x:hover{
    cursor: pointer;
}

.tournament_item_ubication_city{
    background: var(--new-green-color);
    border: 2px solid var(--new-green-color);
    border-radius: 47px;
    padding: var(--space-half);
    margin: 5px;
    display: flex;
    justify-content: space-between;
}

.tournament_match_filter_item.toggle_button_group .MuiToggleButton-root.MuiToggleButtonGroup-grouped{
    border: 0.5px solid var(--new-gray-background-color);
    border-radius: 4px;
    padding: 5px 10px;
}

.tournament_match_filter_item.toggle_button_group .MuiToggleButton-root.MuiToggleButtonGroup-grouped .MuiToggleButton-label{
    text-transform: capitalize;
}

.tournament_match_filter_item.toggle_button_group .MuiToggleButton-root.MuiToggleButtonGroup-grouped.MuiToggleButtonGroup-groupedHorizontal.Mui-selected{
    color: var(--new-green-color) !important;
    background: #E6F6EC;
}

.tournament_match_filter_item .tournament_match_filter_item_radio_buttons{
    margin-bottom: var(--space-half);
}

.tournament_match_filter_item_radio_title.baloa-table{
    font-weight: var(--font-medium);
    color: var(--primary-very-dark-color);
}

.tournament-match-admin-filter-item__info-team {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
}

.tournament-match-admin-filter-item__info-team img {
    width: 24px;
    height: 24px;
    border-radius: 50%;
}

.tournament-match-admin-filter-item__info-team .icon-ball {
    color: var( --white-color );
    font-size: 18px;
    border-radius: 50%;
    padding: 4px;
    height: 25px;
}

.tournament_match_filter_item__input-search {
    display: flex;
    align-items: center;
    border-bottom: 1px solid var(--new-gray-background-color);
    padding: 10px;
}

.tournament_match_filter_item__input-search input {
    min-width: calc(var(--space-x3) * 8);
    border: 1px solid var( --new-gray-background-color);
    /* min-height: var( --space-x3 ); */
    border-radius: 8px;
    background: var( --new-background-color );
    padding: 10px var(--space-half) 10px var(--space-x3);
}

.tournament_match_filter_item__input-search .icon-search {
    position: absolute;
    font-size: calc( var( --space ) + var( --space-quarter ) );
    color: #949F9A;
    margin-left: calc( var( --space ) - var( --space-eighth ) );
}

.tournament_match_filter_item__spinner-container {
    padding: 50px 0;
}

.tournament_match_filter_item__loader {
    border: 6px solid var(--basic-green-color);
    border-bottom-color: transparent;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    animation: spin 2s linear infinite;
    margin: auto;
}

:focus-visible {
    outline: none;
}

.tournament_match_filter_item_checkbox_label__referee .baloa-table {
    color: var(--primary-very-dark-color);
}

.tournament_match_filter_item_checkbox_label__referee .baloa-username {
    color: var(--primary-dark-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */


}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-match-admin-filter-item/TournamentMatchAdminFilterItem.styles.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,wCAAwC;AAC5C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,yBAAyB;AAC7B;AACA;IACI,yCAAyC;IACzC,6BAA6B;IAC7B,yBAAyB;AAC7B;AACA;IACI,yCAAyC;IACzC,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,wCAAwC;IACxC,mBAAmB;IACnB,0BAA0B;IAC1B,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,oDAAoD;IACpD,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;IAC/B,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yDAAyD;IACzD,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,mDAAmD;IACnD,mCAAmC;IACnC,kBAAkB;IAClB,yCAAyC;IACzC,oDAAoD;AACxD;;AAEA;IACI,kBAAkB;IAClB,0DAA0D;IAC1D,cAAc;IACd,2DAA2D;AAC/D;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0CAA0C;IAC1C,gCAAgC;IAChC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;AACpC;;AAEA,yCAAyC,4BAA4B;;;AAGrE","sourcesContent":[".tournament_match_filter_item, .tournament_match_filter_item__checkbox-list {\n    max-height: 300px;\n    padding: 16px 20px;\n}\n\n.tournament_match_filter_item .MuiToggleButtonGroup-root{\n    display: flex;\n    /* grid-template-columns: 35% 35% 35%; */\n    border-radius: 4px;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n}\n\n.tournament_match_filter_item_checkbox{\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: var(--space-half-quarter);\n}\n\n.tournament_filter{\n    margin: var(--space) 0;\n}\n\n.tournament_match_filter_item_checkbox_label.baloa-table {\n    color: var(--primary-very-dark-color);\n}\n\n.tournament_match_filter_item_checkbox_label#Scheduled{\n    background-color: #3078B3;\n    padding: var(--space-quarter);\n    color: var(--white-color);\n}\n.tournament_match_filter_item_checkbox_label#Finalized{\n    background-color: var(--basic-gray-color);\n    padding: var(--space-quarter);\n    color: var(--white-color);\n}\n.tournament_match_filter_item_checkbox_label#Not_scheduled{\n    background-color: var(--new-yellow-color);\n    padding: var(--space-quarter);\n    color: var(--white-color);\n}\n\n.tournament_item_ubication_city.baloa-username{\n    color: var(--white-color);\n    font-weight: var(--font-medium);\n}\n\n.tournament_item_ubication_city .icon-x{\n    color: var(--white-color);\n}\n\n.tournament_item_ubication_city .icon-x:hover{\n    cursor: pointer;\n}\n\n.tournament_item_ubication_city{\n    background: var(--new-green-color);\n    border: 2px solid var(--new-green-color);\n    border-radius: 47px;\n    padding: var(--space-half);\n    margin: 5px;\n    display: flex;\n    justify-content: space-between;\n}\n\n.tournament_match_filter_item.toggle_button_group .MuiToggleButton-root.MuiToggleButtonGroup-grouped{\n    border: 0.5px solid var(--new-gray-background-color);\n    border-radius: 4px;\n    padding: 5px 10px;\n}\n\n.tournament_match_filter_item.toggle_button_group .MuiToggleButton-root.MuiToggleButtonGroup-grouped .MuiToggleButton-label{\n    text-transform: capitalize;\n}\n\n.tournament_match_filter_item.toggle_button_group .MuiToggleButton-root.MuiToggleButtonGroup-grouped.MuiToggleButtonGroup-groupedHorizontal.Mui-selected{\n    color: var(--new-green-color) !important;\n    background: #E6F6EC;\n}\n\n.tournament_match_filter_item .tournament_match_filter_item_radio_buttons{\n    margin-bottom: var(--space-half);\n}\n\n.tournament_match_filter_item_radio_title.baloa-table{\n    font-weight: var(--font-medium);\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-match-admin-filter-item__info-team {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 4px;\n}\n\n.tournament-match-admin-filter-item__info-team img {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n}\n\n.tournament-match-admin-filter-item__info-team .icon-ball {\n    color: var( --white-color );\n    font-size: 18px;\n    border-radius: 50%;\n    padding: 4px;\n    height: 25px;\n}\n\n.tournament_match_filter_item__input-search {\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid var(--new-gray-background-color);\n    padding: 10px;\n}\n\n.tournament_match_filter_item__input-search input {\n    min-width: calc(var(--space-x3) * 8);\n    border: 1px solid var( --new-gray-background-color);\n    /* min-height: var( --space-x3 ); */\n    border-radius: 8px;\n    background: var( --new-background-color );\n    padding: 10px var(--space-half) 10px var(--space-x3);\n}\n\n.tournament_match_filter_item__input-search .icon-search {\n    position: absolute;\n    font-size: calc( var( --space ) + var( --space-quarter ) );\n    color: #949F9A;\n    margin-left: calc( var( --space ) - var( --space-eighth ) );\n}\n\n.tournament_match_filter_item__spinner-container {\n    padding: 50px 0;\n}\n\n.tournament_match_filter_item__loader {\n    border: 6px solid var(--basic-green-color);\n    border-bottom-color: transparent;\n    border-radius: 50%;\n    width: 60px;\n    height: 60px;\n    animation: spin 2s linear infinite;\n    margin: auto;\n}\n\n:focus-visible {\n    outline: none;\n}\n\n.tournament_match_filter_item_checkbox_label__referee .baloa-table {\n    color: var(--primary-very-dark-color);\n}\n\n.tournament_match_filter_item_checkbox_label__referee .baloa-username {\n    color: var(--primary-dark-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
